import _ from 'lodash';
import axios from 'axios';
import {EntityFieldTO} from 'generated/JavaTO'

class FieldDict {
	private models: EntityFieldTO[];
	private _byEntityField: Record<string, EntityFieldTO>
	private _byDq: Record<string, EntityFieldTO>

	/**
	 * @param models must be distinct by entity
	 */
	constructor(models: EntityFieldTO[] = []) {
		this.models = models;
		this._byEntityField = _.keyBy(_.filter(this.models, f => f.entityField), "entityField") as Record<string, EntityFieldTO>
		this._byDq = _.keyBy(_.filter(this.models, f => f.dq2Value), "dq2Value") as Record<string, EntityFieldTO>
	}

	getEntityField(name: string) {
		return this._byEntityField[name];
	}

	getDqField(dqkey: string) {
		return this._byDq[dqkey];
	}

	getFilterableFields() {
		return _.filter(this.models, f => f.filterable);
	}

	getSortableFields() {
		return _.filter(this.models, f => f.sortable);
	}
}

// fetch interface

const FieldDictAPIUrlDict: Record<EntityFieldEntity, string> = {
	pers: '../json/person/fielddict',
	kost: '../json/kost/fielddict',
};

enum EntityFieldEntity {
	kost = 'kost',
	pers = 'pers'
}

const instances: Record<EntityFieldEntity, null | Promise<FieldDict>> = {
	pers: null,
	kost: null,
}

export const fetchFieldDict = (entity: EntityFieldEntity) => {
	if (!instances[entity]) {
		instances[entity] = axios.get<EntityFieldTO[]>(FieldDictAPIUrlDict[entity])
			.then(({data}) => new FieldDict(data));
	}
	return instances[entity]
};

